import { useEffect, useState } from 'react';
import { TitleTextInputStyled } from './TitleTextInput.styles';

interface Props {
  /*
   * The text displayed in the text field if a value is already set in the DB
   */
  initialValue?: string;
  /*
   * The placehoplder text in the text field if there is no initialValue or no new typed value
   */
  placeholder?: string;
  /*
   * The function called on change
   */
  onChange: (newText: string) => void;
  /*
   * Data attribute used to select element
   */
  'data-testid'?: string;
  /*
   * Should the onChange function be called whenever the text is changed or only onBlur
   */
  updateTextOnChange?: boolean;
  updateTextOnBlur?: boolean;
  disabled?: boolean;
}

export const TitleTextInput = ({
  initialValue,
  onChange,
  updateTextOnChange,
  placeholder = '',
  updateTextOnBlur,
  ...props
}: Props) => {
  const [value, setValue] = useState(initialValue ?? '');
  useEffect(() => setValue(initialValue ?? ''), [initialValue]);

  const valueToCalculateWidth = value || placeholder;

  return (
    <TitleTextInputStyled
      {...props}
      type="text"
      value={value}
      placeholder={placeholder}
      onChange={(e) => {
        setValue(e.target.value);
        if (updateTextOnChange) {
          onChange(e.target.value);
        }
      }}
      onBlur={(e) => {
        if (updateTextOnBlur) {
          onChange(e.target.value);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.currentTarget.blur();
          onChange(value);
        }
      }}
      width={valueToCalculateWidth ? valueToCalculateWidth.length * 0.9 : ''}
      disabled={props.disabled}
    />
  );
};
